import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { REAL_WEDDINGS } from '../data/mock';
import { Link } from 'react-router-dom';

export default function RealWeddings() {
  return (
    <main className="pt-32">
      <section className="max-w-[1340px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Real Weddings</SectionLabel>
        <Heading className="mt-5 font-serif max-w-4xl">Real people. Real places. <span className="italic">Remarkable celebrations.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg">Don’t just look at the final photograph. Discover the story behind each wedding — the destination, the idea, the people, the details.</p>
      </section>

      <section className="max-w-[1340px] mx-auto px-6 md:px-10 pb-24">
        <div className="space-y-10">
          {REAL_WEDDINGS.map((w, i) => (
            <Link to="/plan" key={w.couple} className={`group grid md:grid-cols-2 gap-10 items-center ${i%2===1 ? 'md:[&>*:first-child]:order-2':''}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={w.image} alt={w.couple} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
              </div>
              <div>
                <div className="eyebrow text-[#a6894f]">{w.destination} · {w.guests} guests</div>
                <h3 className="font-serif text-4xl md:text-5xl text-[#053e49] mt-3">{w.couple}</h3>
                <div className="hairline mt-5 w-20" />
                <p className="mt-5 font-serif italic text-xl text-[#304247]">“{w.quote}”</p>
                <p className="mt-5 text-sm text-[#6b7c80]">{w.services}</p>
                <span className="link-underline eyebrow text-[#a6894f] mt-6 inline-block">Read the story →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
